var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"signup-policy"},[(!_vm.showSignupForms)?_c('ServicePolicies',{on:{"agree":_vm.handleAgree}}):_c('SignupForms')],1)}
var staticRenderFns = []

export { render, staticRenderFns }